__turbopack_context__.v({
  "Button": "animated-hamburger-module___JoR2q__Button",
  "Line": "animated-hamburger-module___JoR2q__Line",
});
